import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/user.slice.js";
import { login, logout } from "../../../redux/user/user.thunk.js";
import { ensureFirebaseAuthListener, maybeDispatchHashLogin } from "./firebaseAuthListener.js";

export const useAuth = () => {
    const { user, isLoadingUser } = useSelector(selectUser);
    const dispatch = useDispatch();

    useEffect(() => {
        ensureFirebaseAuthListener();
        maybeDispatchHashLogin();
    }, []);

    const logoutUser = () => {
        dispatch(logout());
    };

    const loginUser = async (data) => {
        return new Promise((resolve, reject) => {
            return dispatch(login(data))
                .then((_userData) =>
                    !_userData?.error ? resolve(_userData) : reject(_userData?.error)
                )
                .catch(() => {
                    reject(false);
                });
        });
    };

    const getIdToken = async () => {
        return await user.getIdTokenResult().then((idTokenRes) => idTokenRes);
    };

    return {
        user,
        logoutUser,
        loginUser,
        isLoadingUser,
        getIdToken,
    };
};
